import { SessionParticipantInfo } from './session-participant-info.model';
import { UserMapper } from 'app/user';

export class SessionParticipantInfoMapper {
  public static map(sessionData: any): SessionParticipantInfo {
    return new SessionParticipantInfo(
        sessionData.isFeedbackFinished,
        sessionData.isSelfEvaluationFinished,
        UserMapper.map(sessionData.user),
        sessionData.feedbackStatus,
        sessionData.selfEvaluationStatus
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session-participant-info.mapper.ts